module.exports = __webpack_public_path__ + "img/recipe.c6ba5776.png";